import React from 'react';
import { useSpinradContext } from '../../context/SpinradContext';
import { ValChip, ValRow } from './styles';

interface ValueChipsProps {
  selected: string[];
  onToggle: (name: string) => void;
}

const ValueChips: React.FC<ValueChipsProps> = ({ selected, onToggle }) => {
  const { coreValues } = useSpinradContext();

  return (
    <ValRow>
      {coreValues.map(v => (
        <ValChip
          key={v}
          type="button"
          $selected={selected.includes(v)}
          onClick={() => onToggle(v)}
        >
          {v}
        </ValChip>
      ))}
    </ValRow>
  );
};

export default ValueChips;
